// Generated by ReScript, PLEASE EDIT WITH CARE

import * as React from "react";

function fromString(s) {
  switch (s) {
    case "black" :
        return /* Black */0;
    case "blue" :
        return /* Blue */4;
    case "green" :
        return /* Green */3;
    case "red" :
        return /* Red */2;
    case "white" :
        return /* White */1;
    default:
      return ;
  }
}

function toString(c) {
  switch (c) {
    case /* Black */0 :
        return "black";
    case /* White */1 :
        return "white";
    case /* Red */2 :
        return "red";
    case /* Green */3 :
        return "green";
    case /* Blue */4 :
        return "blue";
    
  }
}

function select(selectedColor, colorOnChange) {
  var opt = function (c) {
    return React.createElement("option", {
                key: toString(c),
                value: toString(c)
              }, toString(c));
  };
  return React.createElement("select", {
              value: toString(selectedColor),
              onChange: colorOnChange
            }, opt(/* Black */0), opt(/* Red */2), opt(/* Green */3), opt(/* Blue */4), opt(/* White */1));
}

export {
  fromString ,
  toString ,
  select ,
  
}
/* react Not a pure module */
